import React from 'react';
import './Offers.css'
import hero from '../../../Assert/offerpage.png'
import Card from '../../../Components/Shared/Card/Card';
import { useSelector } from 'react-redux'

const Offers = () => {

    const productList = useSelector((state) => state.cart.allProducts)


    return (
        <div className="">
            <div className="w-4/5 mx-auto mt-16 pt-2">
                <img src={hero} className='w-full' alt="" />
            </div>
            <div className="mb-4 py-2 bg-gray-300">
                <div className="text-sm breadcrumbs">
                    <ul>
                        <li>
                            <a href='/'>Home</a>
                        </li>
                        <li>
                            <a href='/'>Documents</a>
                        </li>
                        <li>Add Document</li>
                    </ul>
                </div>
            </div>
            <div className='grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 '>
                {
                    productList?.map((product) => (
                        <Card key={product._id} product={product} />

                    )
                    )
                }
            </div>
        </div>
    );
};

export default Offers;